export const LOADING_COMPETENCY = "LOADING_COMPETENCY";
export const SAVE_LOADING_COMPETENCY = "SAVE_LOADING_COMPETENCY";
export const GET_COMPETENCY = "GET_COMPETENCY";
export const FORM_FAIL = "FORM_FAIL";
export const COMPETENCY_FAIL = "COMPETENCY_FAIL";
